import { THEME } from '../../utils/theme';

const Spinner = ({ size = 20, color = THEME.success }) => (
  <div style={{
    width: size, height: size, border: `2px solid ${THEME.border}`, borderTopColor: color,
    borderRadius: '50%', animation: 'spin 0.8s linear infinite'
  }} />
);

export default Spinner;
